import React from "react";
import PropTypes from "prop-types";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import Box from "reusecore/src/elements/Box";
import Text from "reusecore/src/elements/Text";
import Heading from "reusecore/src/elements/Heading";
import Card from "reusecore/src/elements/Card";
import Button from "reusecore/src/elements/Button";
import Image from "../../../components/Image";
import FeatureBlock from "../../../components/FeatureBlock";
import Container from "../../../components/Container";
import BlockWrapper, { SectionObject } from "./Block.style";
import { FiArrowRight } from "react-icons/fi";
import { buttonStyle } from "reusecore/src/theme/customVariant";
import { navigate } from "gatsby";

const Block = ({
  titleStyle,
  subtitleStyle,
  descriptionStyle,
  textAreaStyle,
  imageWrapper,
  title,
  subtitle,
  content,
  index,
  left,
  image,
  additional
}) => {
  return (
    <BlockWrapper id={`feature-${index}`} left={left} index={index}>
      <SectionObject left={left}>
        <Card className="objectWrapper" {...imageWrapper}>
          <Fade left={!left} right={left}>
            <Image filename={image} alt={`feature-${index}-image`} />
          </Fade>
        </Card>
      </SectionObject>
      <Container>
        <Box {...textAreaStyle(left)}>
          <FeatureBlock
            title={<Heading content={title} {...titleStyle} />}
            subtitle={<Heading content={subtitle} {...subtitleStyle} />}
            description={
              <>
                {content.map(text => (
                  <Text content={text} {...descriptionStyle} />
                ))}
              </>
            }
            additionalContent={additional}
          />
        </Box>
      </Container>
    </BlockWrapper>
  );
};

Block.propTypes = {
  titleStyle: PropTypes.object,
  descriptionStyle: PropTypes.object,
  btnStyle: PropTypes.object
};

Block.defaultProps = {
  textAreaStyle: isLeft => ({
    width: ["100%", "100%", "45%"],

    ml: [0, 0, isLeft ? "auto" : "50%"],
    mr: [0, 0, isLeft ? "50%" : "auto"]
  }),
  imageWrapper: {
    boxShadow: "none",
    width: "100%"
  },
  titleStyle: {
    fontSize: ["24px", "32px"],
    fontWeight: "900",
    color: "#32325d",
    mb: "4px",
    letterSpacing: "-0.010em",
    maxWidth: ["100%", "100%", "100%", "440px", "440px"],
    lineHeight: "1.5"
  },
  subtitleStyle: {
    fontSize: ["24px", "32px"],
    fontWeight: "400",
    color: "rgba(52, 61, 72, 0.5)",
    mb: "32px",
    maxWidth: ["100%", "100%", "100%", "440px", "440px"],
    lineHeight: "1.5"
  },
  descriptionStyle: {
    fontSize: ["18px", "22px"],
    color: "#343d48cc",
    lineHeight: "1.8",
    mb: "1rem",
    maxWidth: ["100%", "100%", "100%", "440px", "440px"]
  }
};

export default Block;
